import gql from 'graphql-tag';

const SET_IMPORTANT_DATA = gql`
  mutation VocabularyAsImportant($id: Int!, $is_important: Int!) {
    vocabulary_important(id: $id, is_important: $is_important) {
      id
      is_important
    }
  }
`;

const SET_IMPORTANT_DATA_MSB = gql`
  mutation VocabularyAsImportant($id: Int!, $is_important: Int!) {
    markImportant(id: $id, is_important: $is_important) {
      id
      is_important
    }
  }
`;

export { SET_IMPORTANT_DATA, SET_IMPORTANT_DATA_MSB };
